import { render, staticRenderFns } from "./Issue-type.vue?vue&type=template&id=7910dac8"
import script from "./Issue-type.vue?vue&type=script&lang=js"
export * from "./Issue-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports